<script>
import Tcell from '../tcell/tcell'
import { PREFIX } from '../../config'
export default {
  props: {
    columns: {
      type: Array, // 列
      default: () => []
    },
    data: {
      type: Array, // 数据
      default: () => []
    },
    row: {
      type: Object, // 行数据
      default: () => null
    },
    rowIndex: {
      type: Number, // 行下标
      default: () => null
    },
    group: {
      type: Object, // 分组
      default: () => ({
        key: 'default'
      })
    },
    groupIndex: {
      type: Number, // 行下标
      default: () => null
    }
  },
  inject: ['table'],
  data () {
    return {
      style: {
        display: 'block',
        height: null
      }
    }
  },
  computed: {},
  created () {
    this.getColumnsStore()
  },
  mounted () {
    this.init()
    this.updateStyle()
  },
  watch: {
    'table.style': {
      deep: true,
      handler (val, oldval) {
        this.updateStyle()
      }
    }
  },
  methods: {
    // 初始化处理
    init () {
      this.$emit('saveRef', 'tableHead', this)
      // 更新行高
     this.$nextTick(()=>{
      const { height } = this.$el.getBoundingClientRect()
      if (this.data[this.rowIndex]) {
        this.data[this.rowIndex]._style = {
          height: Math.max(
            height,
            this.data[this.rowIndex]?._style?.height || 0
          )
        }
      }
      this.style.height = this.data[this.rowIndex]?._style?.height || height
     })

    },
    updateHead () {
      this.$forceUpdate()
    },
    // 跟新 样式
    updateStyle () {
      const { style } = this.table
      if (style.scrollWidth <= style.width) {
        this.style.display = 'flex'
      } else {
        this.style.display = 'inline-block'
      }
    },
    renderColumns () {
      const { columns } = this.getColumnsStore()
      const render = (columns) => {
        return columns.reduce((acc, column, columnIndex) => {
          acc.push(
            <Tcell
              key={column.style || columnIndex}
              {...{
                props: {
                  column,
                  row: this.row,
                  tableHeadStyle: this.style,
                  prefix: PREFIX,
                  columnIndex: columnIndex,
                  rowIndex: this.rowIndex,
                  group: this.group,
                  groupIndex: this.groupIndex
                }
              }}
            />
          )
          return acc
        }, [])
      }
      return render(columns)
    },
    // 预留位置处理多级表头数据
    getColumnsStore () {
      const { columns } = this
      return { columns }
    },
    handleScroll (e) {
      this.$emit('scroll', e)
    }
  },
  components: {
    Tcell
  },
  render (h) {
    const { style, row, rowIndex } = this
    return (
      <div
        id={`row-${rowIndex === null ? '-1' : rowIndex}`}
        class={{ [`${PREFIX}-body-row`]: row, [`${PREFIX}-thead`]: !row }}
        style={{
          display: style.display,
          height: style.height + 'px'
        }}
        on-scroll={this.handleScroll}
      >
        {this.renderColumns()}
      </div>
    )
  }
}
</script>
<style scoped lang="scss">
.sy-virtual-table-thead {
  white-space: nowrap;
  width: 100%;
  overflow: auto;
  background: #f1f6ff;
  ::v-deep {
    .sy-virtual-table-column {
      margin: 0;
      padding: 8px;
      flex: 1;
      box-sizing: border-box;
      background: #f1f6ff;
    }
    .sy-virtual-table-column-title {
      white-space: initial;
    }
    .is-center {
      text-align: center;
    }
    .sy-virtual-table-column-fixed-left{
      // position: absolute !important;
    }
  }
}
.sy-virtual-table-thead::-webkit-scrollbar{
  display: none; /* Chrome Safaris */
}
.sy-virtual-table-body-row {
  white-space: nowrap;
  ::v-deep {
    .sy-virtual-table-column {
      margin: 0;
      padding: 8px;
      flex: 1;
      box-sizing: border-box;
      background: #fff;
      font-weight: 400;
      border-bottom: 1px solid #d6dfff;
    }
    .sy-virtual-table-column-title {
      white-space: initial;
    }

    .is-center {
      text-align: center;
    }
  }
}
::v-deep {
  // .fiexd-box-shadow-left,.fiexd-box-shadow-right {
  //   .sy-virtual-table-column-fixed-left {
  //     box-shadow: 5px 0 3px rgba(0, 0, 0, 0.12);
  //   }
  //   .sy-virtual-table-column-fixed-right {
  //     box-shadow: -5px 0 3px rgba(0, 0, 0, 0.12);
  //   }
  // }
}
.sy-virtual-table-body-row:hover .sy-virtual-table-column {
  // background: #F8FAFF;
  cursor: pointer;
}
</style>
